import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { FromNoDDL } from "../../../../../CommonDDL/FromNoDDL";



export const ActionReport = () => {
    const { t } = useTranslation()
    const navigate = useNavigate();
    return (
        <div className="row  m-1 mt-2 " >
            <div className="col-12 col-lg-12  " >
                <div className="row bg-white rounded_eic my-2" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }}>

                    <div className="col-12">
                        {/* Action Taken */}
                        <div className="row my-3">
                            <div className="col-12 col-lg-2">
                                <span className="text-dark  py-3 all_heading_fontsize">
                                    {t('EncroachmentDashboard.ActionTaken')}
                                </span>

                            </div>
                            <div className="col-12 col-lg-2 ">
                                <FromNoDDL />
                            </div>

                            <div className="col-12 col-lg-8 text-end pb-2 mb-2">
                                <div className="btn-group" role="group" aria-label="Basic radio toggle button group">
                                    <input type="radio" className="btn-check" name="btnradio7" id="sky18" autocomplete="off" checked />
                                    <label className="btn btn-outline-primary fw-bold" for="sky18">{t('EncroachmentDashboard.Total')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky28" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky28">{t('EncroachmentDashboard.ZoneA')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky38" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky38">{t('EncroachmentDashboard.ZoneB')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky48" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky48">{t('EncroachmentDashboard.ZoneC')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky58" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky58">{t('EncroachmentDashboard.ZoneD')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky68" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky68">{t('EncroachmentDashboard.ZoneE')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky78" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky78">{t('EncroachmentDashboard.ZoneF')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky88" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky88">{t('EncroachmentDashboard.ZoneG')}</label>

                                    <input type="radio" className="btn-check" name="btnradio7" id="sky98" autocomplete="off" />
                                    <label className="btn btn-outline-primary" for="sky98">{t('EncroachmentDashboard.ZoneH')}</label>
                                </div>
                            </div>




                            <div className="col-12 col-md-12 col-lg-12 col-xl-6 pb-3 cursor-pointer"
                            // onClick={() => navigate('/ReceivedComplaintGrid')}
                            >
                                <div className="px-4 pb-2 pt-4 rounded_eic background_style2  gray_bg_eic" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row">
                                        {/* Verified notices*/}
                                        <div className="col-12 col-md-6 col-lg-6 pb-3 cursor-pointer"
                                            onClick={() => navigate('/VerifiedNoticesIllegalGrid')}
                                        >
                                            <div className="p-4 background_style eic_PurpleColor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', borderRadius: '5px' }} >
                                                <div className="row">
                                                    <div className="col-9">
                                                        <h6 className=" text-dark">{t('EncroachmentDashboard.ServeNotice')}</h6>
                                                        <h2 className="pt-2 fw-bold text-danger">25</h2>
                                                    </div>
                                                    <div className="col-3 d-flex align-items-center justify-content-center ">
                                                        <img src="./assets/img/eic_img/Issue_Notice.png" style={{ width: '40px' }} alt="" srcset="" />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Forward Complaint */}
                                        <div className="col-12 col-md-6 col-lg-6 pb-3 cursor-pointer"
                                            onClick={() => navigate('/CourtCasesIllegalGrid')}
                                        >
                                            <div className="p-4 background_style eic_Yellowcolor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', borderRadius: '5px' }} >
                                                <div className="row">
                                                    <div className="col-9">
                                                        <h6 className="text-dark">{t('EncroachmentDashboard.CourtCases')}</h6>
                                                        <h2 className="pt-2 fw-bold text-danger">10</h2>
                                                    </div>
                                                    <div className="col-3 d-flex align-items-center justify-content-center ">
                                                        <img src="./assets/img/eic_img/Court_Cases.png" style={{ width: '40px' }} alt="" srcset="" />
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="col-12 col-md-12 col-lg-12 col-xl-6 pb-3 cursor-pointer"
                                onClick={() => navigate('/ClosedComplaintIllegalGrid')}
                            >
                                <div className="px-4 pb-2 pt-3 rounded_eic background_style eic_BlueColor" style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px' }} >
                                    <div className="row">
                                        <div className="col-12 d-flex justify-content-between pb-2">
                                            <span className=" text-dark fw-bold fs-5">{t('EncroachmentDashboard.ClosedComplaint')}</span>
                                            <span className="fw-bold text-danger fs-3">15</span>
                                            <img src="./assets/img/eic_img/Closed_Complaint.png" style={{ width: '40px' }} alt="" srcset="" />
                                        </div>


                                        <div className="col-12 col-md-4 col-lg-4">
                                            <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                                <h6 className=" text-dark">{t('EncroachmentDashboard.SarthiPortal')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">8</h2>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-4">
                                            <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                                <h6 className=" text-dark">{t('EncroachmentDashboard.SocialMedia')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">4</h2>
                                            </div>
                                        </div>
                                        <div className="col-12 col-md-4 col-lg-4">
                                            <div className="px-2 bg-white rounded pt-3 text-center border border-3">
                                                <h6 className=" text-dark">{t('EncroachmentDashboard.OfficerVisit')}</h6>
                                                <h2 className="pt-2 fw-bold text-danger">3</h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}